import { Box } from "@mui/material";
import React from "react";
import ReactTimeAgo from "react-time-ago";

import { Typography } from "new-components/typography/Typography";
import { ImageQuery } from "types/imageQueries";
import { getColorText, getImageBarColor, getLabeledIcon, getOpacity, translateBoundingBoxesLabelToFrontend } from "utils/imageQueriesUtils";


interface AnswerBarProps {
  imageQuery: ImageQuery;
  answer: string;
  showTimestamp?: boolean;
  showConfidence?: boolean;
  confidence?: string;
  titleSuffix?: string;
  small?: boolean;
}

export function AnswerBar(props: AnswerBarProps) {

  const {
    imageQuery,
    answer,
    titleSuffix = undefined,
    confidence = undefined,
    showTimestamp = false,
    showConfidence = false,
    small = false
  } = props;

  const textColor = getColorText(imageQuery);
  const barColor = getImageBarColor(imageQuery);

  const translatedAnswer = translateBoundingBoxesLabelToFrontend(answer);

  return (

    <Box
      id="answer-bar"
      sx={{
        display: "flex",
        width: "100%",
        alignContent: "flex-start",
        justifyContent: "space-between",
        alignItems: "center",
        color: textColor,
        height: small ? "24px" : "30px",
        px: "10px",
        opacity: getOpacity(imageQuery),
        backgroundColor: barColor,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          width: "100%",
          marginRight: "auto",
          gap: "4px",
          placeContent: "space-between",
        }}
      >
        {imageQuery.iq_id && getLabeledIcon(imageQuery)}
        <Box
          sx={{
            display: "flex",
            gap: "0.2rem",
            overflow: "hidden",
            marginRight: "auto",
          }}
        >
          <Typography variant="detail" fontWeight="semibold" className={`truncate ${textColor}`}>
            {translatedAnswer}
            {titleSuffix && answer.toLowerCase() !== "unclear" && (
              <Typography variant="detail" fontWeight="semibold" className={`truncate ${textColor}`}>
                {titleSuffix}
              </Typography>
            )}
          </Typography>
          {showConfidence && (
            <Typography variant="detail" className={`${textColor}`}>
              {confidence}
            </Typography>
          )}
        </Box>

        {showTimestamp && (
          <Typography variant="detail" className={`whitespace-nowrap ${textColor}`}>
            <ReactTimeAgo date={imageQuery?.created_at ? new Date(imageQuery?.created_at) : 0} locale="en-US" />
          </Typography>
        )}
      </Box>
    </Box>
  )
}
